<template>
  <div class="contract-body">

    <!-- 搜索 -->
    <div class="search-wrap">
      <el-button size="mini" v-if="ERP.isPermission(26005001002001)" type="primary" @click="editArea()" icon="el-icon-plus">添加区域</el-button>
      <!-- <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>
      <el-button size="mini" type="primary" @click="search()" :loading="searchLoading">搜索</el-button> -->
    </div>

    <!-- 区域树 -->
    <div class="area-wrap">
      <el-tree :props="props" :load="loadNode" :data="data" node-key="id" :empty-text="emptyText" lazy :highlight-current="true" :default-expanded-keys="defExpKeys" @node-expand="nodeExpand" @node-collapse="nodeCollapse">
        <div class="custom-tree-node" slot-scope="{ node, data }">
          <div class="area-info">{{ node.label }}<span class="area-manager">{{ data.manager }}</span></div>
          <div class="area-opt">
            <el-tag size="mini" v-if="ERP.isPermission(26005001002001)" @click="(e) => editArea(e, {parent_id: data.id})"><i class="el-icon-plus"></i>添加</el-tag>
            <el-tag size="mini" v-if="ERP.isPermission(26005001002002)" @click="(e) => editArea(e, data)"><i class="el-icon-edit"></i>编辑</el-tag>
            <el-tag type="danger" v-if="ERP.isPermission(26005001002003)" size="mini" @click="(e) => removeArea(e, data)"><i class="el-icon-delete"></i>删除</el-tag>
          </div>
        </div>
      </el-tree>
    </div>

    <!-- 添加窗口 -->
    <el-dialog title="添加区域" :visible.sync="dialogVisible" :close-on-click-modal="true" class="area-dialog" width="600px">

      <el-form ref="form" :rules="rules" :model="form" label-width="100px" size="mini" class="area-form">
        <el-form-item label="区域名称" prop="name">
          <el-input v-model="form.name" placeholder="请填写区域名称"></el-input>
        </el-form-item>
        <el-form-item label="上级" prop="parent_name" >
<!--          v-if="form.id == '' || (form.id > 0 && form.parent_id > 0)"-->
<!--          <el-tag size="small" v-if="form.id">{{form.parent_name}}</el-tag>-->
          <div style="display: flex;">
            <el-input v-model="form.parent_name" readonly placeholder="留空时为大区域"></el-input>
            <el-button type="primary" style="margin-left: 5px;" @click="showAreaSelector()">选择</el-button>
          </div>
        </el-form-item>
        <el-form-item label="负责人" prop="manager">
          <el-input v-model="form.manager" placeholder="请填写负责人名称"></el-input>
        </el-form-item>
        <el-form-item label="负责人电话" prop="manager_phone">
          <el-input v-model="form.manager_phone" placeholder="请填写负责人电话"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" type="textarea" :rows="3"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit()" :loading="submitLoading">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>

    <area-selector :visible.sync="areaSelectorVisible" @selected="areaSelected"></area-selector>

  </div>
</template>

<script>

  import AreaSelector from './AreaSelector.vue'
  import { Area , get } from './common.js'
  import CommonHelp from "./common/CommonHelp";

export default {
  name:"ContractArea",
  components: {
    'area-selector': AreaSelector
  },
  data () {
    return {
      keyword: '',
      searchLoading: false,
      submitLoading: false,
      dialogVisible: false,
      areaSelectorVisible: false,
      form: {},
      defValue: {
        id: '',
        parent_id: '',
        parent_name: '-',
        name: '',
        manager: '',
        manager_phone: '',
        remark: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入区域名称。', trigger: 'blur' },
        ],
      },

      props: {
        label: 'name',
        children: 'children',
        isLeaf: 'leaf',
      },
      data: [],
      emptyText: '',
      defEmptyText: '暂无数据',
      defExpKeys: [],
    }
  },
  beforeMount() {
    this.resetForm()
  },
  watch: {
    // dialogVisible(val) {
    //   if(val == false) {
    //     this.resetForm()
    //   }
    // }
  },
  // computed:{
  //   full_name(){
  //     return
  //   }
  // },
  created() {
    this.getAreaList()
  },
  methods: {
    download() {
      get('area/download', {}, res => {
        console.log(res.code , res.code == 0)
        if(res.code == 0){
          console.log(res.data)
          let path = res.data.path;
          window.open(CommonHelp.getBaseURL() + path)
        }
      });
    },
    getAreaList() {
      this.emptyText = '正在加载数据...'
      Area.getAreaList({parent_id: 0}, res => {
        this.emptyText = this.defEmptyText
        this.data = res.data
      })
    },
    editArea(e, data) {

      if(data) {
        this.form = Object.assign({}, this.defValue, data)
        this.getAreaFullName()
      } else {
        this.resetForm()
      }

      this.dialogVisible = true
      if(e) e.stopPropagation()
    },
    removeArea(e, data) {

      this.$confirm(`此操作将删除 [ ${data.name} ] 及其子区域，是否继续?`, '提示', {type: 'warning'}).then(() => {
        Area.deleteArea({id: data.id}, res => {
          this.message(res)
          if(res.code == 0) this.getAreaList()
        })
      })

      e.stopPropagation()
    },
    submit() {

      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.saveArea()
        } else {
          return false;
        }
      });

    },
    resetForm() {
      this.form = Object.assign({}, this.defValue)
    },
    saveArea() {

      this.submitLoading = true
      let data = Object.assign({}, this.form)
      Area.saveArea(data, res => {
        this.submitLoading = false
        this.message(res)
        if(res.code == 0) {
          this.resetForm()
          this.dialogVisible = false
          this.getAreaList()
        }
      })

    },

    message(res) {
      this.$message({type: res.code == 0 ? 'success' : 'error', message: res.msg})
    },

    showAreaSelector() {
      this.areaSelectorVisible = true
    },

    areaSelected(data) {

      if(data.id == this.form.id) {
         this.$message.error('上级不能选择自己')
         return false
      }

      this.form.parent_id = data.id
      this.getAreaFullName()
    },

    getAreaFullName() {
      let that = this
      if(that.form.parent_id == '') return false
      Area.getAreaFullName({id: that.form.parent_id}, res => {

        that.form = Object.assign({}, that.form, {parent_name: res.data.join(' -> ')})
      })
    },

    loadNode(node, resolve) {
      if(node.data.id) {
        Area.getAreaList({parent_id: node.data.id}, res => {
          resolve(res.data)
        })
      }
    },

    nodeExpand(data, node, obj) {
      if(this.defExpKeys.includes(node.key) == false) {
        this.defExpKeys.push(node.key)
      }
    },

    nodeCollapse(data, node) {
      let k = this.defExpKeys.indexOf(node.key)
      if(k !== -1) this.defExpKeys.splice(k, 1)
    }

  }
}
</script>
<style lang="scss" scoped>

@import './common2.scss';

.area-dialog {

  .area-form {
    margin-right: 50px;
  }
}

.area-wrap {
  margin-top: 15px;
  max-width: 600px;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 5px;
  overflow: auto;
  height: 600px;
}

/deep/.custom-tree-node {
  flex: 1;
  display: flex;
  justify-content: space-between;

  .area-info {
    font-size: 14px;
  }

  .area-manager {
    padding-left: 5px;
    color: #999;
  }

  .area-opt {
    margin-right: 5px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/Area.vue